const config = {
  server: "http://localhost:27279",
  ip: "http://localhost",
};
export default config;
